import React from 'react';
import { Modal, Form, Upload, Button, Space, Alert, Input, Grid } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

const { Dragger } = Upload;
const { useBreakpoint } = Grid;

const EfirmaModal = ({
  visible,
  onCancel,
  onFinish,
  form,
  selectedCompany,
  loading,
}) => {
  const screens = useBreakpoint();

  return (
    <Modal
      title="Subir eFirma (FIEL)"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={screens.xs ? '100%' : 600}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Alert
          message="Archivos requeridos"
          description={`Sube tu eFirma (.cer y .key) con su contraseña. Se asociará a la empresa: ${selectedCompany?.tax_name} - ${selectedCompany?.tax_id}`}
          type="info"
          showIcon
          style={{ marginBottom: '24px' }}
        />

        <Form.Item
          name="certificate"
          label="Archivo de Certificado (.cer)"
          rules={[{ required: true, message: 'El archivo .cer es requerido' }]}
        >
          <Dragger beforeUpload={() => false} accept=".cer" maxCount={1} height={160}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Haz clic o arrastra el archivo .cer aquí</p>
            <p className="ant-upload-hint">Soporta solo archivos con extensión .cer</p>
          </Dragger>
        </Form.Item>

        <Form.Item
          name="private_key"
          label="Llave Privada (.key)"
          rules={[{ required: true, message: 'El archivo .key es requerido' }]}
        >
          <Dragger beforeUpload={() => false} accept=".key" maxCount={1} height={160}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Haz clic o arrastra el archivo .key aquí</p>
            <p className="ant-upload-hint">Soporta solo archivos con extensión .key</p>
          </Dragger>
        </Form.Item>

        <Form.Item
          name="password"
          label="Contraseña de la Llave Privada"
          rules={[{ required: true, message: 'La contraseña es requerida' }]}
        >
          <Input.Password placeholder="Contraseña de la llave privada" />
        </Form.Item>

        <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
          <Space>
            <Button onClick={onCancel}>Cancelar</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Subir eFirma
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EfirmaModal;

